import type {
	ShopDto,
	UpdateShopDisapprovalReasonDto,
} from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateDisapprovalReason(shop: ShopDto) {
	return useApiMutation(
		"patch",
		"/shops/{shopId}/disapproval-reasons/{reasonId}",
		{
			invalidate: useInvalidateShop(shop.id),
			mapVariables: ({
				reasonId,
				...body
			}: UpdateShopDisapprovalReasonDto & { reasonId: string }) => ({
				params: { path: { shopId: shop.id, reasonId } },
				body,
			}),
		},
	);
}
